export default __webpack_public_path__ + "static/media/480_portfolio03-en-mobile.d5e2f8db.png";